import type { ShopifyMapAuditFinding, ShopifyMapAuditIssue } from '../services/api';

/** Audit issues Motzu can repair by pushing catalog price / compare-at. */
export const AUDIT_RESYNC_ISSUES: ShopifyMapAuditIssue[] = [
  'stale_price',
  'stale_compare_at',
  'missing_live_price',
];

export function isAuditFindingResyncable(issues: ShopifyMapAuditIssue[] | undefined): boolean {
  return (issues || []).some((issue) => AUDIT_RESYNC_ISSUES.includes(issue));
}

export function auditResyncTargetKey(row: Pick<ShopifyMapAuditFinding, 'integrationId' | 'productId'>): string {
  return `${row.integrationId}:${row.productId}`;
}

export function uniqueAuditResyncTargets(
  findings: ShopifyMapAuditFinding[],
): Array<{ productId: string; integrationId: string; key: string }> {
  const seen = new Set<string>();
  const out: Array<{ productId: string; integrationId: string; key: string }> = [];
  for (const row of findings) {
    if (!isAuditFindingResyncable(row.issues)) continue;
    if (!row.productId || !row.integrationId) continue;
    if (row.intendedPrice == null && row.intendedCompareAtPrice == null) continue;
    const key = auditResyncTargetKey(row);
    if (seen.has(key)) continue;
    seen.add(key);
    out.push({ productId: row.productId, integrationId: row.integrationId, key });
  }
  return out;
}
